module.exports = __webpack_public_path__ + "img/5bbe0e6.png";